import { useEffect } from 'react';

export default function useLocalStoragePersistence({
  signatures,
  dimensions,
  labels,
  labelsMatch,
  fieldFunction,
}) {
  useEffect(() => {
    localStorage.setItem('signatures', JSON.stringify(signatures));
    localStorage.setItem('dimensions', JSON.stringify(dimensions));
    localStorage.setItem('selectedLabels', JSON.stringify(labels));
    localStorage.setItem('selectedLabelsMatch', JSON.stringify(labelsMatch));
    localStorage.setItem('selectedFunctions', JSON.stringify(fieldFunction));
  }, [signatures, dimensions, labels, labelsMatch, fieldFunction]);
}
